"use client";

import { Calendar, Clock, MapPin, Music, Utensils, Camera } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface TimelineEvent {
  id: number;
  time: string;
  title: string;
  description: string;
  icon: typeof Calendar;
}
const scheduleEvents: TimelineEvent[] = [{
  id: 1,
  time: "5:30 PM",
  title: "Ceremony Begins",
  description: "Join us at Le Clos de Faqra as we exchange vows surrounded by mountain views and Italian-inspired greenery.",
  icon: Calendar
}, {
  id: 2,
  time: "6:30 PM",
  title: "Cocktail Hour",
  description: "Enjoy refreshing drinks and light appetizers while mingling with guests in the elegant outdoor setting.",
  icon: Utensils
}, {
  id: 3,
  time: "7:30 PM",
  title: "Reception Entrance",
  description: "Celebrate with us as we make our grand entrance to begin the evening festivities.",
  icon: Music
}, {
  id: 4,
  time: "8:00 PM",
  title: "Dinner Service",
  description: "Savor a delicious multi-course dinner featuring Mediterranean-inspired cuisine.",
  icon: Utensils
}, {
  id: 6,
  time: "10:00 PM",
  title: "Dancing & Celebration",
  description: "Dance the night away with live music and DJ entertainment until midnight.",
  icon: Music
}];
function TimelineCard({
  event,
  index
}: {
  event: TimelineEvent;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const Icon = event.icon;
  const isEven = index % 2 === 0;
  return <div ref={ref} data-index={index} className={`flex items-center gap-6 transition-all duration-150 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-2.5 opacity-0"}`} style={{
    transitionDelay: `${index * 50}ms`
  }}>
      {}
      <div className="relative flex h-full min-h-[120px] w-12 shrink-0 items-center justify-center">
        <div className="absolute left-1/2 top-0 h-full w-0.5 -translate-x-1/2 bg-primary/20" />
        <div className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full bg-primary shadow-soft transition-all duration-120 group-hover:bg-primary-hover group-hover:shadow-medium">
          <Icon className="h-5 w-5 text-foreground-primary transition-all duration-120 group-hover:scale-110" />
        </div>
      </div>

      {}
      <Card className="group flex-1 border-border bg-muted-light-background px-6 py-4 shadow-soft transition-all duration-120 hover:-translate-y-0.5 hover:shadow-medium">
        <CardHeader className="p-0">
          <div className="flex items-baseline justify-between gap-4">
            <CardTitle className="font-display text-xl text-primary">{event.title}</CardTitle>
            <span className="shrink-0 text-sm font-semibold text-secondary">{event.time}</span>
          </div>
        </CardHeader>
        <CardContent className="mt-2 p-0">
          <p className="text-sm leading-relaxed text-foreground">{event.description}</p>
        </CardContent>
      </Card>
    </div>;
}
export default function Schedule() {
  return;
}